var map = {
	"./Body1": [
		"bed5",
		"chunk-2d21b4ca"
	],
	"./Body1.vue": [
		"bed5",
		"chunk-2d21b4ca"
	],
	"./BodyLoader": [
		"ed84"
	],
	"./BodyLoader.vue": [
		"ed84"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "25ac";
module.exports = webpackAsyncContext;